import React, { useEffect, useState } from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';

function Table({ ComponentDaRenderizzare, fetchData, tableHeader }) {
    const [data, setData] = useState([]); // Inizializzato come array vuoto

    useEffect(() => {
        const getData = async () => {
            const result = await fetchData();
            setData(result.data || []);
        };
        getData();
    }, [fetchData]);

    return (
        <table className="table table-hover text-nowrap fs-sm">
            <TableHeader header={tableHeader} />
            <TableBody data={data} ComponentDaRenderizzare={ComponentDaRenderizzare} />
        </table>
    );
}

export default Table;
